import { render } from "./ModalComponent.vue?vue&type=template&id=7bd28a7f&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=7bd28a7f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7bd28a7f"

export default script